import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Entry from './Entry';
import Report from './Report';
import ClosingAndOthers from './ClosingAndOthers';

const RTEModule = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/Entry`} component={Entry} />
    <Route path={`${match.url}/Report`} component={Report} />
    <Route path={`${match.url}/ClosingAndOthers`} component={ClosingAndOthers} />
  </Switch>
);

export default RTEModule;
